import React from 'react';
import styled from 'styled-components';
import Load03 from 'dc/Load03';

const sizes = {
  small: '64px',
  medium: '72px',
  large: '120px',
};

type LoaderProps = {
  size: string;
};

export const Loader = styled(Load03)<LoaderProps>`
  display: block;
  width: ${props => sizes[props.size]};
  height: ${props => sizes[props.size]};
  border-radius: 50%;
`;

type ImageProps = {
  url?: string;
  color?: string;
  size: string;
  className?: string;
  children?: React.ReactNode;
};

export const ImageWrapper = styled.div<ImageProps>`
  border: none;
  border-radius: 50%;
  background: ${props => (props.color ? props.color : 'default')};
  background-image: ${props => (props.url ? `url(${props.url})` : 'none')};
  background-position: center;
  background-size: cover;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: ${props => sizes[props.size]};
  height: ${props => sizes[props.size]};
`;

const fontSizes = {
  small: '24px',
  medium: '24px',
  large: '48px',
};

type InitialsProps = {
  size: string;
};

export const Initials = styled.span<InitialsProps>`
  font-size: ${props => fontSizes[props.size]};
  font-weight: normal;
  line-height: 120%;
  color: #fff;
`;
